import { Head, Link } from "@inertiajs/react"
import { ArrowLeft } from "lucide-react"
import { MemberLayout } from "../components/MemberLayout"
import { WheelSnapshotHistorySection } from "@/components/planning/WheelSnapshotHistorySection"

/**
 * Coach read-only wheel timeline for a member. Members are redirected from
 * BalanceWheel::HistoryController to the dashboard Life Assessment tab.
 */
export default function History({
  currentUser,
  snapshots = [],
  readOnly = false,
  member = null,
  backHref = null,
}) {
  const heading = readOnly && member ? `${member.name} — Integrated Life Audit history` : "Integrated Life Audit History"

  return (
    <>
      <Head title={readOnly && member ? `${member.name} — Integrated Life Audit history` : "Integrated Life Audit History"} />
      <MemberLayout currentUser={currentUser}>
        <div className="max-w-4xl mx-auto px-4 sm:px-6 py-8">
          {backHref && (
            <Link
              href={backHref}
              className="inline-flex items-center gap-1 text-sm text-zinc-600 hover:text-zinc-900 mb-4"
            >
              <ArrowLeft className="w-4 h-4" />
              Back
            </Link>
          )}

          <h1 className="font-display text-3xl mb-2">{heading}</h1>
          <p className="text-zinc-500 mb-6">
            Every snapshot — initial intake, monthly seeds, locked quarter audits, and standalone
            retakes — in chronological order.
          </p>

          <WheelSnapshotHistorySection snapshots={snapshots} embedded={false} />
        </div>
      </MemberLayout>
    </>
  )
}
